export default "__VITE_ASSET__BHtXAtlE7bokZjR_HOSUDA__"